module.exports = __webpack_public_path__ + "img/reisen_sc1.a562554a.png";